import CubesImg from "public/encryptedStorage/implementation/fa6-solid_cubes.png";
import RocketImg from "public/encryptedStorage/implementation/fa6-solid_rocket.png";
import BoltImg from "public/encryptedStorage/implementation/material-symbols_bolt-rounded.png";
import LockOffImg from "public/encryptedStorage/implementation/tdesign_lock-off-filled.png";
import SecuredImg from "public/encryptedStorage/implementation/tdesign_secured-filled.png";
import ConfigImg from "public/encryptedStorage/implementation/stash_last-updates.png";

export const IMPLEMENTATION_CONSTANTS = {
  title: "Implementing Encrypted Storage Clusters",
  desc: "To deploy an Encrypted Storage Cluster, consider the following steps:",
  list: [
    {
      image: CubesImg,
      title: "Select Appropriate Software or Platform",
      content:
        "Choose a storage solution that supports encryption and meets your organization's requirements.",
    },
    {
      image: BoltImg,
      title: "Set Up Infrastructure",
      content:
        "Prepare the necessary hardware or virtual machines to host the storage nodes.",
    },
    {
      image: RocketImg,
      title: "Configure Networking",
      content:
        "Ensure secure and reliable network connections between nodes, implementing measures like VPNs or private networks.",
    },
    {
      image: LockOffImg,
      title: "Enable Encryption",
      content:
        "Configure encryption settings to ensure data is encrypted at rest and in transit.",
    },
    {
      image: SecuredImg,
      title: "Implement Access Controls",
      content:
        "Set up authentication and authorization protocols to restrict data access to authorized users only.",
    },
    {
      image: ConfigImg,
      title: "Regular Monitoring and Maintenance",
      content:
        "Continuously monitor the cluster for performance and security, applying updates and patches as necessary.",
    },
  ],
};
